import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { OptionsDictionary } from './SortOptionDefinitions';

export const groupSortOptions: OptionsDictionary = {
  'lastSignIn': {
    id: 'lastSignIn',
    getMenuItemDisplayValue: () => '',
    subSortOptions: {
      'asc': {
        id: 'lastSignIn.asc',
        field: OrderKeys.lastSignIn,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.lastSignIn)]
      },
      'desc': {
        id: 'lastSignIn.desc',
        field: OrderKeys.lastSignIn,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.lastSignIn)]
      }
    }
  },
  'siteRole': {
    id: 'siteRole',
    getMenuItemDisplayValue: () => '',
    subSortOptions: {
      'asc': {
        id: 'siteRole.asc',
        field: OrderKeys.siteRole,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.siteRole)]
      },
      'desc': {
        id: 'siteRole.desc',
        field: OrderKeys.siteRole,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.siteRole)]
      }
    }
  },
  'username': {
    id: 'username',
    getMenuItemDisplayValue: () => '',
    subSortOptions: {
      'asc': {
        id: 'username.asc',
        field: OrderKeys.username,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.username)]
      },
      'desc': {
        id: 'username.desc',
        field: OrderKeys.username,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.username)]
      }
    }
  },
  'displayName': {
    id: 'displayName',
    getMenuItemDisplayValue: () => '',
    subSortOptions: {
      'asc': {
        id: 'displayName.asc',
        field: OrderKeys.displayName,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.displayName)]
      },
      'desc': {
        id: 'displayName.desc',
        field: OrderKeys.displayName,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.displayName)]
      }
    }
  },
  'siteCount': {
    id: 'siteCount',
    getMenuItemDisplayValue: () => '',
    subSortOptions: {
      'asc': {
        id: 'siteCount.asc',
        field: OrderKeys.siteCount,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.siteCount)]
      },
      'desc': {
        id: 'siteCount.desc',
        field: OrderKeys.siteCount,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.siteCount)]
      }
    }
  },
};
